import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Box, Spinner } from "@chakra-ui/react";

// local imports
import useAuthContext from "./hooks/useAuthContext";
import Header from "./components/Header";
import Home from "./pages/Home";
import Dashboard from "./pages/Dashboard";
import ListDetail from "./pages/ListDetail";
import Register from "./pages/Register";

function App() {
  const { user, authLoading } = useAuthContext();

  if (authLoading) {
    return (
      <Box
        display="flex"
        height="100vh"
        width="100%"
        justifyContent="center"
        alignItems="center"
      >
        <Spinner thickness="4px" color="teal.500" size="xl" />
      </Box>
    );
  }

  return (
    <Router>
      <Header />
      <Routes>
        <Route
          path="/"
          element={user ? <Navigate to="/dashboard" /> : <Home />}
        />
        <Route
          path="/dashboard"
          element={user ? <Dashboard user={user} /> : <Navigate to="/auth" />}
        />
        <Route
          path="/dashboard/:listId"
          element={user ? <ListDetail /> : <Navigate to="/auth" />}
        />
        <Route
          path="/auth"
          element={user ? <Navigate to="/dashboard" /> : <Register />}
        />
      </Routes>
    </Router>
  );
}

export default App;
